<script>
    import { getText } from "../../../Utils/utilFunctions.svelte";

    export let exception = "";

    let isShowException = true;

    // HELPER FUNCTIONS
    const _toggleShowHideDetails = () => {
        isShowException = !isShowException;
    };
</script>

<div
    class={`transition flex flex-col w-full lg:flex-row ${
        isShowException ? "" : "max-h-[50px]"
    }`}
>
    <div
        class="flex-1 h-full card bg-white rounded-box border"
    >
        <div
            class="flex justify-between pr-4 text-white cursor-pointer bg-gradient-to-b from-bg-primary to-bg-secondary"
            on:click|preventDefault={_toggleShowHideDetails}
        >
            <p class="font-bold px-2 py-4">Exception</p>
        </div>

        <div class="flex flex-col flex-1 px-2 py-4 w-full lg:flex-row">
            <div class="flex flex-col flex-1 gap-y-4 h-full">
                <div class="flex flex-row gap-x-2">
                    {#if exception}
                        <p class="content break-all">
                            {getText(exception)}
                        </p>
                    {:else}
                        <p class="content">No exception</p>
                    {/if}
                </div>
            </div>
        </div>
    </div>
</div>

<style>
    .content {
        width: calc(100% - 50px);
    }

    .transition {
        transition: 0.5s linear;
    }
</style>
